import { get, post, remove } from "../common/http.services";

export function searchMasterData(searchModel: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/masterdata/search/?page=${pageNumber}&size=${pageSize}`, searchModel, appContext, success, error);
}

export function exportMasterData(searchModel: any, appContext: any, success: any, error: any) {
    return post(`/masterdata/export`, searchModel, appContext, success, error);
}

export function searchMasterDetailData(searchModel: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/masterdata/searchcostingdata/?page=${pageNumber}&size=${pageSize}`, searchModel, appContext, success, error);
}

export function getMasterDataById(id: any, appContext: any, success: any, error: any) {
    return get(`/masterdata/findbyid?id=${id}`, appContext, success, error);
}

export function getMasterDataByCodeAndSupplier(code: any, supplier: any, appContext: any, success: any, error: any) {
    return get(`/masterdata/codeandsupplier?code=${code}&supplier=${supplier}`, appContext, success, error);
}

export function getOtherCostValues(appContext: any, success: any, error: any) {
    return get(`/masterdata/specvalue?input=Costing&spec=Other Cost`, appContext, success, error);
}

export function getMasterDataSpecs(input: any, appContext: any, success: any, error: any) {
    return get(`/masterdata/specs?input=${input}`, appContext, success, error);
}

export function findMasterDataBySku(sku: any, appContext: any, success: any, error: any) {
    return get(`/masterdata/findbysku?sku=${sku}`, appContext, success, error);
}

export function getPendingMasterData(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/masterdata/pending?page=${pageNumber}&size=${pageSize}&sort=updateDate,desc`, appContext, success, error);
}

export function approveMasterData(id: any, appContext: any, success: any, error: any) {
    return post(`/masterdata/approve?id=${id}`, null, appContext, success, error);
}

export function saveMasterData(masterDataModel: any, appContext: any, success: any, error: any) {
    return post(`/masterdata`, masterDataModel, appContext, success, error);
}

export function deleteMasterData(id: any, appContext: any, success: any, error: any) {
    return remove(`/masterdata?id=${id}`, appContext, success, error);
}
